import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import IBIcon from '@swf/core/assets/casino/instant-bonus.svg';
import type { InstantBonus } from '@swf/core/types/InstantBonus';
import { isActive } from '@swf/core/utils/casino';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import sharedStyles from '../InstantBonusSharedTile.scss';

import { TXTWCL_Bonus_Amount } from './RegularBonus.messages.json';

interface Props {
  ib: InstantBonus;
}

const RegularBonus: React.FC<Props> = ({ ib }) => (
  <div
    className={classNames({
      [sharedStyles.regular]: true,
      [sharedStyles.disabled]: !isActive(ib) || ib.paused
    })}
  >
    <IBIcon />
    <div className={classNames(sharedStyles.info)}>
      <div className={sharedStyles.price}>
        <CurrencyAmount
          value={isActive(ib) ? ib.currentAmount : ib.initialAmount}
          currency={ib.currency}
        />
      </div>
      <div className={sharedStyles.bonusAmount}>
        <span>
          <Translation {...TXTWCL_Bonus_Amount} />
        </span>
      </div>
    </div>
  </div>
);

export default RegularBonus;
